import { ClassificationToSection, ListCategoryDTO, Section } from '../orderProducts.types';

export const emptyDefaultSection: Section = {
  availability: undefined,
  deliveryWindow: undefined,
  productsCount: 0,
  addProducts: [],
  isExpanded: true,
  products: [],
};

export const emptyCategory: ListCategoryDTO = {
  name: '-',
  id: null,
  imageUrl: '',
  children: [],
  uniqueSequential: 0,
  classification: '',
};

export const emptyClassification: ClassificationToSection = {
  name: '-',
  code: '',
  id: null,
  description: '',
  classificationType: { id: '', name: '', useAsFilter: false, useAsTag: false },
};
